// Recovered compiled webpack factory 27123. Edit this function expression; run npm run build.
(e, t, r) => {
  "use strict";
  r.d(t, { LE: () => l, V7: () => u, lu: () => c });
  var n = r(89135),
    a = r(22758),
    o = r(31209),
    i = r(47434),
    s = r(51290);
  function l(e, t, r, n) {
    let i = (0, o.Cj)(r),
      s = {
        sent_at: new Date().toISOString(),
        ...(i && { sdk: i }),
        ...(!!n && t && { dsn: (0, a.SB)(t) }),
      },
      l = "aggregates" in e ? [{ type: "sessions" }, e] : [{ type: "session" }, e.toJSON()];
    return (0, o.h4)(s, [l]);
  }
  function u(e, t, r, n) {
    let a = (0, o.Cj)(r),
      i = e.type && "replay_event" !== e.type ? e.type : "event";
    !(function (e, t) {
      if (!t) return;
      let r = e.sdk || {};
      e.sdk = {
        ...r,
        name: r.name || t.name,
        version: r.version || t.version,
        integrations: [...(e.sdk?.integrations || []), ...(t.integrations || [])],
        packages: [...(e.sdk?.packages || []), ...(t.packages || [])],
        settings: e.sdk?.settings || t.settings ? { ...e.sdk?.settings, ...t.settings } : void 0,
      };
    })(e, r?.sdk);
    let s = (0, o.n2)(e, a, n, t);
    delete e.sdkProcessingMetadata;
    let l = [{ type: i }, e];
    return (0, o.h4)(s, [l]);
  }
  function c(e, t) {
    let r = (0, n.k1)(e[0]),
      l = t?.getDsn(),
      u = t?.getOptions().tunnel,
      c = {
        sent_at: new Date().toISOString(),
        ...(!!r.trace_id && !!r.public_key && { trace: r }),
        ...(!!u && l && { dsn: (0, a.SB)(l) }),
      },
      { beforeSendSpan: f, ignoreSpans: d } = t?.getOptions() || {},
      p = d?.length ? e.filter((e) => !(0, i.e)((0, s.et)(e), d)) : e,
      h = e.length - p.length;
    h && t?.recordDroppedEvent("before_send", "span", h);
    let _ = f
        ? (e) => {
            let t = (0, s.et)(e),
              r = f(t);
            return r || ((0, s.xl)(), t);
          }
        : s.et,
      m = [];
    for (let e of p) {
      let t = _(e);
      t && m.push((0, o.y5)(t));
    }
    return (0, o.h4)(c, m);
  }
}
